const { createBrowserHistory } = require('history')

let history
function getHistory () {
  if (!history) {
    history = createBrowserHistory()
  }
  return history
}

module.exports = getHistory
